function scrollToInviteForm(): void {
  document.getElementById("invite-as-speaker-cta")?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
}

export default function InviteAsSpeakerHero() {
  return (
    <section
      id="invite-as-speaker-hero"
      className="w-full bg-black py-10 font-fira text-white"
    >
      <div className="mx-auto w-[90%] md:w-[98%] ">
        <div className="rounded-b-2xl rounded-t-none p-px md:rounded-b-3xl">
          <div className="relative  md:min-h-[80dvh] overflow-hidden rounded-3xl border border-[#FFFFFF29] md:rounded-b-3xl">
            <picture className="pointer-events-none absolute inset-0">
              <source
                media="(min-width: 768px)"
                srcSet="/business/vaibhavd.webp"
              />
              <img
                src="/business/vaibhavm.webp"
                alt=""
                className="h-full w-full object-cover object-center"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </picture>

            <div className="pointer-events-none absolute inset-0" />

            <div className="relative z-10 flex min-h-[70dvh] flex-col justify-end px-8 py-12 md:justify-center md:px-16 md:py-16 lg:px-24">
              <div className="flex flex-col items-start md:max-w-2xl">
                <h1 className="font-fira-condensed text-[36px] font-medium leading-tight tracking-tight text-white md:text-[56px] md:font-semibold">
                  Invite Vaibhav

                  to your stage
                </h1>

                <p className="font-fira mt-3 text-[14px] font-normal leading-relaxed text-[#FFFFFF80] md:mt-4 md:text-[18px]">
                  Keynotes, AI workshops, and fireside chats - for summits,
                  conferences, and corporate offsites.
                </p>

                <div className="mt-6 hidden w-full flex-col items-center gap-3 md:mt-8 md:flex md:flex-row">
                  <button
                    type="button"
                    onClick={scrollToInviteForm}
                    className="w-full rounded-lg border border-[#FFFFFF4D] bg-white px-5 py-2.5 font-fira text-sm font-semibold text-black transition-opacity hover:opacity-90 md:px-6 md:text-[0.9375rem]"
                  >
                    Enquire about Availability
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
